export default  {
    content: [
      {
        "headline": "Archaeology news: Golden eagle carved into volcanic rock discovered in Aztec temple",
        "description": "ARCHAEOLOGISTS carrying out excavations in an ancient Aztec temple have discovered a carving of a golden eagle dating back more than 600 years.",
        "image": "https://cdn.images.express.co.uk/img/dynamic/151/590x/archaeology-news-aztec-1393552.webp?r=1612600956358",
        "link": "https://www.express.co.uk/news/science/1393552/archaeology-news-aztec-empire-golden-eagle-templo-mayor-evg",
        "author": "Sean Martin",
        "source": "Daily Express",
        "tags": "Aztec, Carving, temple, Eagle, Mexico"
      },
      {
        "headline": "Does the Brewer Cave Story Unlock a Hidden History?",
        "description": "This sensational story opened up a whole new level of connections with other similar discoveries, furthering the possibility that there actually might be some truth to the hard-to-believe story of ancient giants.",
        "image": "https://www.ancient-origins.net/sites/default/files/field/image/brewer-cave.jpg",
        "link": "https://www.ancient-origins.net/myths-legends-americas/brewer-cave-0012778",
        "author": "Aleksa Vuckovic",
        "source": "Ancient-Origins",
        "tags": "Brewer's Cave, Giants, Plates, Sanpete, Manti, Terry Carter, John, Red Hair, Mummies"
      },
      {
        "headline": "Mysterious Petroglyphs in the Western US",
        "description": "Accross the Western United States a mystery is unfolding.",
        "image": "https://storage.googleapis.com/rockiestocumorahserver.appspot.com/rockiestocumorah/mystery-glyphs/mystery-glyph-fillmore-3.JPG",
        "link": "http://www.mysteryglyphs.com/pages/Articles/20061029-002A.pdf",
        "author": "Terry Carter and Shawn Davies",
        "source": "Mystery Glyphs",
        "tags": "Mystery Glyphs, Petroglyphs, Hieroglyphs, Egyptian, Mayan, Aztec, Western United States"
      }
     ]
}